module.exports = {
	"contractName": "BankFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "0x6080604052600436106100485763ffffffff60e060020a6000350416637726f776811461004d5780638da5cb5b1461007d578063d38def5b14610092578063f2fde38b146100cd575b600080fd5b610061600160a060020a03600435166100f0565b60408051600160a060020a039092168252519081900360200190f35b34801561008957600080fd5b506100616101bc565b34801561009e57600080fd5b506100b9600160a060020a03600435811690602435166101cb565b604080519115158252519081900360200190f35b3480156100d957600080fd5b506100ee600160a060020a0360043516610264565b005b6000806001546100fe6102f8565b90815260405190819003602001906000f080158015610121573d6000803e3d6000fd5b50905080600160a060020a031663a9059cbb846002546040518363ffffffff1660e060020a0281526004018083600160a060020a0316600160a060020a0316815260200182815260200192505050602060405180830381600087803b15801561018957600080fd5b505af115801561019d573d6000803e3d6000fd5b505050506040513d60208110156101b357600080fd5b50909392505050565b600054600160a060020a031681565b60008083905060025481600160a060020a03166370a08231856040518263ffffffff1660e060020a0281526004018082600160a060020a0316600160a060020a03168152602001915050602060405180830381600087803b15801561022f57600080fd5b505af1158015610243573d6000803e3d6000fd5b505050506040513d602081101561025957600080fd5b505111949350505050565b600054600160a060020a0316331461027b57600080fd5b600160a060020a038116151561029057600080fd5b60008054604051600160a060020a03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a36000805473ffffffffffffffffffffffffffffffffffffffff1916600160a060020a0392909216919091179055565b6040516101f880610309833901905600608060405234801561001057600080fd5b506040516020806101f883398101604090815290516001819055336000908152602081905291909120556101af806100496000396000f3006080604052600436106100565763ffffffff7c010000000000000000000000000000000000000000000000000000000060003504166318160ddd811461005b57806370a0823114610082578063a9059cbb146100b0575b600080fd5b34801561006757600080fd5b506100706100f5565b60408051918252519081900360200190f35b34801561008e57600080fd5b5061007073ffffffffffffffffffffffffffffffffffffffff600435166100fb565b3480156100bc57600080fd5b506100e173ffffffffffffffffffffffffffffffffffffffff60043516602435610123565b604080519115158252519081900360200190f35b60015481565b73ffffffffffffffffffffffffffffffffffffffff1660009081526020819052604090205490565b3360009081526020819052604081205482900381111561014257600080fd5b50336000908152602081905260408082208054849003905573ffffffffffffffffffffffffffffffffffffffff8416825290208054820190556001929150505600a165627a7a7230582067dccc1821976b447c67104a78f4a0ecc06196b9243d28939f6bf94643f79d510029a165627a7a723058203f71a833668d84bb17ec25cd1f92eeae0737fb025c63cc9e9b701730d5b9ffa90029",
	"sourceMap": "75:454:2:-;;;126:8;109:25;;161:2;138:25;;-1:-1:-1;501:18:29;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;75:454:2;;;;;;",
	"deployedSourceMap": "75:454:2:-;;;;;;;;;-1:-1:-1;;;75:454:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;168:172;;-1:-1:-1;;;;;168:172:2;;;;;;;;;-1:-1:-1;;;;;168:172:2;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;344:183:2;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;344:183:2;-1:-1:-1;;;;;344:183:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;168:172:2;233:7;248:9;269:6;;260:16;;:::i;:::-;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;260:16:2;248:28;;282:4;-1:-1:-1;;;;;282:13:2;;296:7;305:12;;282:36;;;;;-1:-1:-1;;;282:36:2;;;;;;;-1:-1:-1;;;;;282:36:2;-1:-1:-1;;;;;282:36:2;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;282:36:2;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;282:36:2;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;331:4:2;;168:172;-1:-1:-1;;;168:172:2:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;344:183:2:-;430:4;444:9;461;444:27;;510:12;;484:4;-1:-1:-1;;;;;484:14:2;;499:7;484:23;;;;;-1:-1:-1;;;484:23:2;;;;;;;-1:-1:-1;;;;;484:23:2;-1:-1:-1;;;;;484:23:2;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;484:23:2;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;484:23:2;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;484:23:2;:38;;344:183;-1:-1:-1;;;;344:183:2:o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;75:454:2:-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.18;\n\nimport \"./base/Level.sol\";\nimport \"./Bank.sol\";\n\ncontract BankFactory is Level {\n  uint256 supply = 14657921;\n  uint256 playerSupply = 29;\n\n  function createInstance(address _player) public payable returns (address) {\n    Bank bank = new Bank(supply);\n    bank.transfer(_player, playerSupply);\n    return bank;\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    Bank bank = Bank(_instance);\n    return bank.balanceOf(_player) > playerSupply;\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/BankFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/BankFactory.sol",
		"exportedSymbols": {
			"BankFactory": [
				269
			]
		},
		"id": 270,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 211,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:2"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 212,
				"nodeType": "ImportDirective",
				"scope": 270,
				"sourceUnit": 2867,
				"src": "26:26:2",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Bank.sol",
				"file": "./Bank.sol",
				"id": 213,
				"nodeType": "ImportDirective",
				"scope": 270,
				"sourceUnit": 210,
				"src": "53:20:2",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 214,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "99:5:2",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 215,
						"nodeType": "InheritanceSpecifier",
						"src": "99:5:2"
					}
				],
				"contractDependencies": [
					209,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 269,
				"linearizedBaseContracts": [
					269,
					2866,
					2922
				],
				"name": "BankFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 218,
						"name": "supply",
						"nodeType": "VariableDeclaration",
						"scope": 269,
						"src": "109:25:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 216,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "109:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3134363537393231",
							"id": 217,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "126:8:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_14657921_by_1",
								"typeString": "int_const 14657921"
							},
							"value": "14657921"
						},
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 221,
						"name": "playerSupply",
						"nodeType": "VariableDeclaration",
						"scope": 269,
						"src": "138:25:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 219,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "138:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3239",
							"id": 220,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "161:2:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_29_by_1",
								"typeString": "int_const 29"
							},
							"value": "29"
						},
						"visibility": "internal"
					},
					{
						"body": {
							"id": 244,
							"nodeType": "Block",
							"src": "242:98:2",
							"statements": [
								{
									"assignments": [
										229
									],
									"declarations": [
										{
											"constant": false,
											"id": 229,
											"name": "bank",
											"nodeType": "VariableDeclaration",
											"scope": 245,
											"src": "248:9:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Bank_$209",
												"typeString": "contract Bank"
											},
											"typeName": {
												"contractScope": null,
												"id": 228,
												"name": "Bank",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 209,
												"src": "248:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Bank_$209",
													"typeString": "contract Bank"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 234,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 232,
												"name": "supply",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 218,
												"src": "269:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 231,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "260:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$_t_uint256_$returns$_t_contract$_Bank_$209_$",
												"typeString": "function (uint256) returns (contract Bank)"
											},
											"typeName": {
												"contractScope": null,
												"id": 230,
												"name": "Bank",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 209,
												"src": "264:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Bank_$209",
													"typeString": "contract Bank"
												}
											}
										},
										"id": 233,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "260:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Bank_$209",
											"typeString": "contract Bank"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "248:28:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 238,
												"name": "_player",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 223,
												"src": "296:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 239,
												"name": "playerSupply",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 221,
												"src": "305:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 235,
												"name": "bank",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 229,
												"src": "282:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Bank_$209",
													"typeString": "contract Bank"
												}
											},
											"id": 237,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 196,
											"src": "282:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
												"typeString": "function (address,uint256) external returns (bool)"
											}
										},
										"id": 240,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "282:36:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 241,
									"nodeType": "ExpressionStatement",
									"src": "282:36:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 242,
										"name": "bank",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 229,
										"src": "331:4:2",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Bank_$209",
											"typeString": "contract Bank"
										}
									},
									"functionReturnParameters": 227,
									"id": 243,
									"nodeType": "Return",
									"src": "324:11:2"
								}
							]
						},
						"documentation": null,
						"id": 245,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 224,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 223,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "192:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 222,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "192:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "191:17:2"
						},
						"payable": true,
						"returnParameters": {
							"id": 227,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 226,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "233:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 225,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "233:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "232:9:2"
						},
						"scope": 269,
						"src": "168:172:2",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 267,
							"nodeType": "Block",
							"src": "438:89:2",
							"statements": [
								{
									"assignments": [
										255
									],
									"declarations": [
										{
											"constant": false,
											"id": 255,
											"name": "bank",
											"nodeType": "VariableDeclaration",
											"scope": 268,
											"src": "444:9:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Bank_$209",
												"typeString": "contract Bank"
											},
											"typeName": {
												"contractScope": null,
												"id": 254,
												"name": "Bank",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 209,
												"src": "444:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Bank_$209",
													"typeString": "contract Bank"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 259,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 257,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 247,
												"src": "461:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 256,
											"name": "Bank",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 209,
											"src": "456:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Bank_$209_$",
												"typeString": "type(contract Bank)"
											}
										},
										"id": 258,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "456:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Bank_$209",
											"typeString": "contract Bank"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "444:27:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 265,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 262,
													"name": "_player",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 249,
													"src": "499:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												],
												"expression": {
													"argumentTypes": null,
													"id": 260,
													"name": "bank",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 255,
													"src": "484:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_Bank_$209",
														"typeString": "contract Bank"
													}
												},
												"id": 261,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "balanceOf",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 208,
												"src": "484:14:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_external_view$_t_address_$returns$_t_uint256_$",
													"typeString": "function (address) view external returns (uint256)"
												}
											},
											"id": 263,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "484:23:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"id": 264,
											"name": "playerSupply",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 221,
											"src": "510:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "484:38:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 253,
									"id": 266,
									"nodeType": "Return",
									"src": "477:45:2"
								}
							]
						},
						"documentation": null,
						"id": 268,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 250,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 247,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 268,
									"src": "370:17:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 246,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "370:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 249,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 268,
									"src": "389:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 248,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "389:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "369:36:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 253,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 252,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 268,
									"src": "430:4:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 251,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "430:4:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "429:6:2"
						},
						"scope": 269,
						"src": "344:183:2",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 270,
				"src": "75:454:2"
			}
		],
		"src": "0:530:2"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/BankFactory.sol",
		"exportedSymbols": {
			"BankFactory": [
				269
			]
		},
		"id": 270,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 211,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:2"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 212,
				"nodeType": "ImportDirective",
				"scope": 270,
				"sourceUnit": 2867,
				"src": "26:26:2",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Bank.sol",
				"file": "./Bank.sol",
				"id": 213,
				"nodeType": "ImportDirective",
				"scope": 270,
				"sourceUnit": 210,
				"src": "53:20:2",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 214,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "99:5:2",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 215,
						"nodeType": "InheritanceSpecifier",
						"src": "99:5:2"
					}
				],
				"contractDependencies": [
					209,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 269,
				"linearizedBaseContracts": [
					269,
					2866,
					2922
				],
				"name": "BankFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 218,
						"name": "supply",
						"nodeType": "VariableDeclaration",
						"scope": 269,
						"src": "109:25:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 216,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "109:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3134363537393231",
							"id": 217,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "126:8:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_14657921_by_1",
								"typeString": "int_const 14657921"
							},
							"value": "14657921"
						},
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 221,
						"name": "playerSupply",
						"nodeType": "VariableDeclaration",
						"scope": 269,
						"src": "138:25:2",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 219,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "138:7:2",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3239",
							"id": 220,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "161:2:2",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_29_by_1",
								"typeString": "int_const 29"
							},
							"value": "29"
						},
						"visibility": "internal"
					},
					{
						"body": {
							"id": 244,
							"nodeType": "Block",
							"src": "242:98:2",
							"statements": [
								{
									"assignments": [
										229
									],
									"declarations": [
										{
											"constant": false,
											"id": 229,
											"name": "bank",
											"nodeType": "VariableDeclaration",
											"scope": 245,
											"src": "248:9:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Bank_$209",
												"typeString": "contract Bank"
											},
											"typeName": {
												"contractScope": null,
												"id": 228,
												"name": "Bank",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 209,
												"src": "248:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Bank_$209",
													"typeString": "contract Bank"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 234,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 232,
												"name": "supply",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 218,
												"src": "269:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 231,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "260:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$_t_uint256_$returns$_t_contract$_Bank_$209_$",
												"typeString": "function (uint256) returns (contract Bank)"
											},
											"typeName": {
												"contractScope": null,
												"id": 230,
												"name": "Bank",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 209,
												"src": "264:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Bank_$209",
													"typeString": "contract Bank"
												}
											}
										},
										"id": 233,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "260:16:2",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Bank_$209",
											"typeString": "contract Bank"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "248:28:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 238,
												"name": "_player",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 223,
												"src": "296:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 239,
												"name": "playerSupply",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 221,
												"src": "305:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 235,
												"name": "bank",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 229,
												"src": "282:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Bank_$209",
													"typeString": "contract Bank"
												}
											},
											"id": 237,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 196,
											"src": "282:13:2",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
												"typeString": "function (address,uint256) external returns (bool)"
											}
										},
										"id": 240,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "282:36:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 241,
									"nodeType": "ExpressionStatement",
									"src": "282:36:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 242,
										"name": "bank",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 229,
										"src": "331:4:2",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Bank_$209",
											"typeString": "contract Bank"
										}
									},
									"functionReturnParameters": 227,
									"id": 243,
									"nodeType": "Return",
									"src": "324:11:2"
								}
							]
						},
						"documentation": null,
						"id": 245,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 224,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 223,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "192:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 222,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "192:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "191:17:2"
						},
						"payable": true,
						"returnParameters": {
							"id": 227,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 226,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "233:7:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 225,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "233:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "232:9:2"
						},
						"scope": 269,
						"src": "168:172:2",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 267,
							"nodeType": "Block",
							"src": "438:89:2",
							"statements": [
								{
									"assignments": [
										255
									],
									"declarations": [
										{
											"constant": false,
											"id": 255,
											"name": "bank",
											"nodeType": "VariableDeclaration",
											"scope": 268,
											"src": "444:9:2",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Bank_$209",
												"typeString": "contract Bank"
											},
											"typeName": {
												"contractScope": null,
												"id": 254,
												"name": "Bank",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 209,
												"src": "444:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Bank_$209",
													"typeString": "contract Bank"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 259,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 257,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 247,
												"src": "461:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 256,
											"name": "Bank",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 209,
											"src": "456:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Bank_$209_$",
												"typeString": "type(contract Bank)"
											}
										},
										"id": 258,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "456:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Bank_$209",
											"typeString": "contract Bank"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "444:27:2"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 265,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 262,
													"name": "_player",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 249,
													"src": "499:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												],
												"expression": {
													"argumentTypes": null,
													"id": 260,
													"name": "bank",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 255,
													"src": "484:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_Bank_$209",
														"typeString": "contract Bank"
													}
												},
												"id": 261,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "balanceOf",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 208,
												"src": "484:14:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_external_view$_t_address_$returns$_t_uint256_$",
													"typeString": "function (address) view external returns (uint256)"
												}
											},
											"id": 263,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "484:23:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"id": 264,
											"name": "playerSupply",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 221,
											"src": "510:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "484:38:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 253,
									"id": 266,
									"nodeType": "Return",
									"src": "477:45:2"
								}
							]
						},
						"documentation": null,
						"id": 268,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 250,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 247,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 268,
									"src": "370:17:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 246,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "370:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 249,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 268,
									"src": "389:15:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 248,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "389:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "369:36:2"
						},
						"payable": false,
						"returnParameters": {
							"id": 253,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 252,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 268,
									"src": "430:4:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 251,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "430:4:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "429:6:2"
						},
						"scope": 269,
						"src": "344:183:2",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 270,
				"src": "75:454:2"
			}
		],
		"src": "0:530:2"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.794Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/BankFactory.json
// module id = 1026
// module chunks = 0